import { useState } from "react"
import { useTranslation } from "react-i18next"
import Input from "../../components/UI/Input/Input"
import { defaultImportData } from "../../DefaultEntries"
import { decrypted_key, useLocalStorage, valid_key } from "../../Utils"
import XORSHIFT128 from "../SeedLister/RNGLib"
import { to_hex } from "../SeedLister/Util/SeedListingLib"
import classes from "./Profile.module.css"

const SeedListing = props => {
    const [reload, setReload] = useState(0)

    const update_data = () => {
        setReload(e => e + 1)
    }
    return <TotalDisplay update_data={update_data} key={reload} />
}

const TotalDisplay = props => {
    const { t } = useTranslation()

    return (
        <>
            <SeedDisplay
                localKey="Lot"
                label={t("translation:CommonMsg.Glossary.Lottery") + " (Normal)"}
                disableInit={!valid_key()}
                updated={props.update_data}
            />
            <SeedDisplay
                localKey="LotFest"
                label={t("translation:CommonMsg.Glossary.Lottery") + " (Splatfest)"}
                disableInit={!valid_key()}
                updated={props.update_data}
            />
            <SeedDisplay
                localKey="Vendor"
                label={t("translation:CommonMsg.Glossary.Vendor")}
                disableInit={!valid_key()}
                updated={props.update_data}
            />
            <SeedDisplay
                localKey="RewardRandomPool_Byname"
                label={t("translation:CommonMsg.Glossary.Byname")}
                disableInit={true}
                updated={props.update_data}
            />
            <SeedDisplay
                localKey="RewardRandomPool_NamePlateBg"
                label={t("translation:CommonMsg.Glossary.NamePlateBg")}
                disableInit={true}
                updated={props.update_data}
            />
        </>
    )
}

const SeedDisplay = props => {
    const { t } = useTranslation()
    const [userData, setUserData] = useLocalStorage("importData", defaultImportData)

    const init_current_seed = () => {
        if (userData.CloudRandomSet === undefined) {
            const rng = new XORSHIFT128(`${decrypted_key()}_${props.localKey}`)
            return rng.get_state()
        }
        const inital_seed = userData.CloudRandomSet.Map[props.localKey]
        return [
            to_hex(inital_seed.Context1),
            to_hex(inital_seed.Context2),
            to_hex(inital_seed.Context3),
            to_hex(inital_seed.Context4),
        ]
    }

    const set_to_inital_seed = () => {
        const rng = new XORSHIFT128(`${decrypted_key()}_${props.localKey}`)
        const res = rng.get_state()
        setCurrentSeed(res.map(e => to_hex(e)))
    }

    const [currentSeed, setCurrentSeed] = useState(init_current_seed())

    const seedValidator = (event, idx) => {
        let inputstr = event.target.value.toUpperCase()
        if (inputstr.substring(0, 2) === "0X") {
            inputstr = inputstr.substring(2)
        }
        inputstr = inputstr.replace(/[^0-9A-F]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0) {
            inputstr = "0"
        }
        inputstr = "0x" + inputstr
        inputstr = inputstr.substring(0, 10) // cut off too many characters
        const old_input = [...currentSeed]
        old_input[idx] = inputstr
        setCurrentSeed(old_input)
    }

    const store_in_database = () => {
        const original = {
            ...userData,
            CloudRandomSet: { ...userData.CloudRandomSet, Map: { ...userData.CloudRandomSet.Map } },
        }
        original.CloudRandomSet.Map[props.localKey] = {
            Context1: parseInt(currentSeed[0], 16),
            Context2: parseInt(currentSeed[1], 16),
            Context3: parseInt(currentSeed[2], 16),
            Context4: parseInt(currentSeed[3], 16),
        }

        setUserData(original)
        props.updated()
        alert("Success")
    }

    return (
        <>
            <h2>{props.label}</h2>
            <div className={classes.GridStyle}>
                <div className={classes.GridElem}>
                    <Input
                        title={t("misc:Checker.CurrentSeed") + " 1"}
                        changed={elem => seedValidator(elem, 0)}
                        val={currentSeed[0]}
                    />
                </div>{" "}
                <div className={classes.GridElem}>
                    <Input
                        title={t("misc:Checker.CurrentSeed") + " 2"}
                        changed={elem => seedValidator(elem, 1)}
                        val={currentSeed[1]}
                    />
                </div>{" "}
                <div className={classes.GridElem}>
                    <Input
                        title={t("misc:Checker.CurrentSeed") + " 3"}
                        changed={elem => seedValidator(elem, 2)}
                        val={currentSeed[2]}
                    />
                </div>{" "}
                <div className={classes.GridElem}>
                    <Input
                        title={t("misc:Checker.CurrentSeed") + " 4"}
                        changed={elem => seedValidator(elem, 3)}
                        val={currentSeed[3]}
                    />
                </div>
            </div>
            <div>
                <button className={classes.Button} onClick={() => setCurrentSeed(["0x0", "0x0", "0x0", "0x0"])}>
                    {t("misc:Profile.ResetSeed")}
                </button>
                {props.disableInit ? null : (
                    <button
                        className={classes.Button}
                        onClick={set_to_inital_seed}
                        title={t("misc:Profile.InitSeedDesc")}
                    >
                        {t("misc:Profile.InitSeed")}
                    </button>
                )}
                <button className={classes.Button} onClick={store_in_database}>
                    {t("misc:Profile.StoreSeed")}
                </button>
            </div>
        </>
    )
}

export default SeedListing
